import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import PendingActionsIcon from '@mui/icons-material/PendingActions'

const APPROVAL_ACTIONS = {
  withOngoing: (onOpenModal: (action: string) => void, label: string) => [
    {
      icon: <PendingActionsIcon />,
      label: 'Ongoing',
      clickHandler: () => onOpenModal('ongoing'),
      type: 'action',
    },

    {
      icon: <CheckIcon />,
      label: label,
      clickHandler: () => onOpenModal('approved'),
      type: 'action',
    },

    {
      icon: <CloseIcon />,
      label: 'Reject',
      clickHandler: () => onOpenModal('rejected'),

      type: 'action',
    },
  ],

  withoutOngoing: (onOpenModal: (action: string) => void, label: string) => [
    {
      icon: <CheckIcon />,
      label: label,
      clickHandler: () => onOpenModal('approved'),
      type: 'action',
    },

    {
      icon: <CloseIcon />,
      label: 'Reject',
      clickHandler: () => onOpenModal('rejected'),
      type: 'action',
    },
  ],
}

export const approvalActions = (
  status: string,
  onOpenModal: (action: string) => void,
  label: string,
) => {
  switch (status) {
    case 'withOngoing':
      return APPROVAL_ACTIONS.withOngoing(onOpenModal, label)
    case 'withoutOngoing':
      return APPROVAL_ACTIONS.withoutOngoing(onOpenModal, label)
  }
}
